// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nvVV8","col":"styles_col__2oDe6"};